
import React, { Component } from "react";
import StackGrid from "react-stack-grid";
import Lightbox from "react-image-lightbox";
import withWidth from '@material-ui/core/withWidth';
import Head from 'next/head';
import ThereIsNoItem from '/components/thereIsNoItem';
import Dashboard from '@material-ui/icons/Dashboard';
import ViewAgenda from '@material-ui/icons/ViewAgenda';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import "react-image-lightbox/style.css";

const styles = {
  root: {
    '&:focus': {
      color: '#ed7123',
    },
  },
};
class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
        columnWidth:'',
        photoIndex: 0,
        isOpen: false,
        width: this.props.width === 'xs' ? '40%' : '33.33%',
        height: true,
        active: true
    };
    this.rowItems = this.rowItems.bind(this)
    this.columnItems = this.columnItems.bind(this);
  }
  rowItems = () => {
   this.setState({
     width: '100%',
     active: false,
     height: false
   }, () => {
    this.grid.updateLayout();
  })
  };
  columnItems = () => {
    this.setState({
      width: this.props.width === 'xs' ? '40%' : '33.33%',
      active: true,
      height: true
    }, () => {
      this.grid.updateLayout();
    })
  };
  render() {
    const { photos, width, classes } = this.props;
    const { photoIndex, isOpen, active, height } = this.state;
    // console.log(this.state.height)
    return (
      <>
      <Head>
        <link rel="stylesheet" href="/static/css/style.css" />
      </Head>
     
      {photos == null ? 
        <ThereIsNoItem thereIsNoItem="No items in this gallery." /> :  
        <>
          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="flex-start"
            >
              <IconButton aria-label="row" onClick={this.rowItems} classes={{root: classes.root}} style={{color: !active ? '#ed7123': '#c5c4c0'}} >
                <ViewAgenda />
              </IconButton>
              <IconButton aria-label="column" onClick={this.columnItems} style={{color: active ? '#ed7123': '#c5c4c0'}} >
                <Dashboard />
              </IconButton>
            
            </Grid>
          <StackGrid style={{zIndex: 1, marginBottom: 15}}
            columnWidth={this.state.width}
            gridRef={grid => this.grid = grid}
            gutterWidth={15}
          >
            {
              photos && photos.map((photo, i) => {
                  let mobileHeight = i % 2 === 0 ? 220 : 140;
                  let desktopHeight =  i % 2 === 0 ? 300 : 220;
                  let height = width === "xs" ? mobileHeight : desktopHeight;
                  return(
                      <img src={photo.teaser} key={i} style={{height: !this.state.height ? 300: `${height}px`, width: '100%', objectFit: 'contain'}} onClick={(e) => this.setState({ isOpen: true, photoIndex: i })} />
                  )
                })
              }
          </StackGrid>

          {/* ************************** For light box ************************* */}

          {isOpen && (
            <Lightbox
              mainSrc={photos[photoIndex].teaser}
              nextSrc={photos[(photoIndex + 1) % photos.length].teaser}
              prevSrc={photos[(photoIndex + photos.length - 1) % photos.length].teaser}
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + photos.length - 1) % photos.length
                })
              }
              onMoveNextRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + 1) % photos.length
                })
              }
            />
          )}
          </>
        }
    </>
    );
  }
}


export default compose(
  withWidth(),
  withStyles(styles))(Gallery);